import * as angular from "angular";

angular
  .module('bringoz.admin.logistics-vehicle')
  .constant('LogisticsVehicleLocation_PN', {
    database: 'logisticsVehicleLocation',
    isBranchEntity: false
  });
